import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/icomoon/style.css";
import "./assets/scss/app.scss";
import "./components";
import "./plugins";
import { init } from "./setup/api";

window.openSupport = function() {
  const iframes = window.document.getElementsByTagName("iframe");
  for (let i in iframes) {
    const button = iframes[i].contentDocument
      ? iframes[i].contentDocument.getElementsByClassName("u-isActionable")
      : false;
    if (button && button.length) {
      button[0].click();
    }
  }
};

Vue.use(BootstrapVue);

init();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window._grecaptcha_callback = () => {
  window.grecaptcha.render({
    sitekey: "6LffniUaAAAAAJLLZgPTRXj_17tS59GQKYD49mqo",
    badge: "bottomleft"
  });
};
